import gql from 'graphql-tag';
export const getConcurrences = gql`
query getConcurrences(
    $input: GetConcurrenceInput) {
      getConcurrences(getConcurrenceInput: $input) {
        leads {
          leadId
          maxConcurrence
        }
  }
}
`;

export const getConcurrencesList = gql`
query getConcurrencesList(
    $input: GetListConcurrenceInput) {
      getConcurrencesList(getListConcurrenceInput: $input) {
        leadId
        contactName
        endDefeatDate
        status
        onTrack
        channel{
          id
          name
          photo
        }
        brand {
          id
          name
          photo
        }
        dealer{
          id
          name
        }
        user{
          id
          name
          lastName
        }
        descriptionModel
        createdAt
        concurrence
        sentToAutonet
      }
  }
`;
